// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1ExWe","modalForm":"UpgradeEpcsModal_modalForm__YHev9","modalFooter":"UpgradeEpcsModal_modalFooter__2Ofq2"};